__turbopack_context__.v({
  "active": "price-history-timeline-module-scss-module__NFClaa__active",
  "activeTitle": "price-history-timeline-module-scss-module__NFClaa__activeTitle",
  "chevronButton": "price-history-timeline-module-scss-module__NFClaa__chevronButton",
  "chevronIcon": "price-history-timeline-module-scss-module__NFClaa__chevronIcon",
  "clickableEntry": "price-history-timeline-module-scss-module__NFClaa__clickableEntry",
  "clickableMiniEntry": "price-history-timeline-module-scss-module__NFClaa__clickableMiniEntry",
  "collapsed": "price-history-timeline-module-scss-module__NFClaa__collapsed",
  "collapsedOverlay": "price-history-timeline-module-scss-module__NFClaa__collapsedOverlay",
  "complianceMessage": "price-history-timeline-module-scss-module__NFClaa__complianceMessage",
  "component": "price-history-timeline-module-scss-module__NFClaa__component",
  "content": "price-history-timeline-module-scss-module__NFClaa__content",
  "contentArea": "price-history-timeline-module-scss-module__NFClaa__contentArea",
  "dateSecondary": "price-history-timeline-module-scss-module__NFClaa__dateSecondary",
  "entries": "price-history-timeline-module-scss-module__NFClaa__entries",
  "entry": "price-history-timeline-module-scss-module__NFClaa__entry",
  "entryContent": "price-history-timeline-module-scss-module__NFClaa__entryContent",
  "expandChipContainer": "price-history-timeline-module-scss-module__NFClaa__expandChipContainer",
  "expandChipOverlay": "price-history-timeline-module-scss-module__NFClaa__expandChipOverlay",
  "group": "price-history-timeline-module-scss-module__NFClaa__group",
  "groupHeader": "price-history-timeline-module-scss-module__NFClaa__groupHeader",
  "header": "price-history-timeline-module-scss-module__NFClaa__header",
  "heading": "price-history-timeline-module-scss-module__NFClaa__heading",
  "headingIcon": "price-history-timeline-module-scss-module__NFClaa__headingIcon",
  "lastSoldPriceCompact": "price-history-timeline-module-scss-module__NFClaa__lastSoldPriceCompact",
  "lastSoldPriceDefault": "price-history-timeline-module-scss-module__NFClaa__lastSoldPriceDefault",
  "leftColumn": "price-history-timeline-module-scss-module__NFClaa__leftColumn",
  "lifecycle": "price-history-timeline-module-scss-module__NFClaa__lifecycle",
  "miniEntry": "price-history-timeline-module-scss-module__NFClaa__miniEntry",
  "miniEntryDot": "price-history-timeline-module-scss-module__NFClaa__miniEntryDot",
  "miniEntryText": "price-history-timeline-module-scss-module__NFClaa__miniEntryText",
  "miniTimeline": "price-history-timeline-module-scss-module__NFClaa__miniTimeline",
  "mls": "price-history-timeline-module-scss-module__NFClaa__mls",
  "modalView": "price-history-timeline-module-scss-module__NFClaa__modalView",
  "neutral": "price-history-timeline-module-scss-module__NFClaa__neutral",
  "neutralTitle": "price-history-timeline-module-scss-module__NFClaa__neutralTitle",
  "originalPrice": "price-history-timeline-module-scss-module__NFClaa__originalPrice",
  "placeholder": "price-history-timeline-module-scss-module__NFClaa__placeholder",
  "price": "price-history-timeline-module-scss-module__NFClaa__price",
  "rightColumn": "price-history-timeline-module-scss-module__NFClaa__rightColumn",
  "sold": "price-history-timeline-module-scss-module__NFClaa__sold",
  "soldTitle": "price-history-timeline-module-scss-module__NFClaa__soldTitle",
  "statCard": "price-history-timeline-module-scss-module__NFClaa__statCard",
  "statContent": "price-history-timeline-module-scss-module__NFClaa__statContent",
  "statIcon": "price-history-timeline-module-scss-module__NFClaa__statIcon",
  "statLabel": "price-history-timeline-module-scss-module__NFClaa__statLabel",
  "statValue": "price-history-timeline-module-scss-module__NFClaa__statValue",
  "statsGrid": "price-history-timeline-module-scss-module__NFClaa__statsGrid",
  "statusChip": "price-history-timeline-module-scss-module__NFClaa__statusChip",
  "thumbnail": "price-history-timeline-module-scss-module__NFClaa__thumbnail",
});
